import { render, staticRenderFns } from "./AddEditAdvisorPopup.vue?vue&type=template&id=055dc3bc"
import script from "./AddEditAdvisorPopup.vue?vue&type=script&lang=ts"
export * from "./AddEditAdvisorPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddEditAdvisorPopup.vue?vue&type=style&index=0&id=055dc3bc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports